import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import localforage from "localforage";
import { TextField, Button, Tabs, Tab } from "@mui/material";
import { filterList } from "../../../libs/utils";
import CustomTable from "../../../components/CustomTable";
import SearchIcon from "@mui/icons-material/Search";
import { getFxRateData } from "../../../services/fxRateCampaignService";
import { useDispatch } from "react-redux";
import { setCompaignId } from "../../../redux/slices/fxRateCampaignSlice";

function FxCompaignList() {
  const [rows, setRows] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [isDynamicTable, setIsDynamicTable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const dispatch = useDispatch();

  const columns = [
    {
      id: "campaign_name",
      label: "Campaign Name",
      minWidth: 80,
      enableSort: true,
    },
    {
      id: "campaign_type",
      label: "Campaign Type",
      minWidth: 100,
      align: "center",
    },
    {
      id: "active",
      label: "Active",
      minWidth: 100,
      align: "center",
      enableSort: true,
    },
    {
      id: "campaign_id",
      label: "Campaign Id",
      minWidth: 100,
      align: "center",
      enableSort: true,
    },
    {
      id: "campaign_fx_rate_type",
      label: "Campaign FX Type",
      minWidth: 100,
      align: "center",
    },

    {
      id: "max_campaign_count",
      label: "Max Campaign Count",
      minWidth: 100,
      align: "center",
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "left",
    },
  ];

  const dataGenerator = (data) => {
    const {
      campaign_name,
      campaign_type,
      campaign_fx_rate_type,
      campaign_id,
      max_campaign_count,
    } = data;
    return {
      campaign_name,
      campaign_type,
      active: String(data.active),
      campaign_id,
      campaign_fx_rate_type,
      max_campaign_count,
      Action: (
        <Link
          to={`/app/fx-rate-campaign/${data.campaign_id}`}
          style={{ textDecoration: "none" }}
        >
          <Button
            variant="contained"
            size="small"
            color="warning"
            onClick={() => dispatch(setCompaignId(campaign_id))}
          >
            Edit
          </Button>
        </Link>
      ),
    };
  };

  useEffect(() => {
    setLoading(true);
    localforage.getItem("@fxcompaign", (error, data) => {
      if (data) {
        if (data?.length > 0 && typeof data === "object") {
          setRows(data.map((data) => dataGenerator(data)));
        } else {
          setRows([]);
        }
      }
    });
    getFxRateData()
      .then((response) => {
        setLoading(false);
        if (response?.fxRateCampaigns?.length > 0) {
          setRows(response?.fxRateCampaigns.map((data) => dataGenerator(data)));
        } else {
          setRows([]);
        }
        localforage.setItem("@fxcompaign", response, (error, data) => {
          if (error) {
            throw error;
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }, []);

  useEffect(() => {
    const savedTab = sessionStorage.getItem("fxRateCampaignTab");
    if (savedTab !== null) {
      setActiveTab(Number(savedTab));
    }
  }, []);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
    sessionStorage.setItem("fxRateCampaignTab", newValue);
  };

  const setDynamicTable = (parentWidth, tableWidth) => {
    setIsDynamicTable(true);
  };

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const activeCampaigns = rows?.filter((row) => row.active === "true") || [];
  const archivedCampaigns = rows?.filter((row) => row.active !== "true") || [];

  return (
    <>
      <Box
        sx={{ px: 6 }}
        className={`main-box ${isDynamicTable ? "dynamicTableStyle" : ""}`}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="campaign tabs"
        >
          <Tab
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                Active Campaigns
                {loading && activeTab === 0 && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "8px", fontSize: "16px" }}
                    aria-hidden="true"
                  ></i>
                )}
              </div>
            }
          />
          <Tab
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                Archived Campaigns
                {loading && activeTab === 1 && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "8px", fontSize: "16px" }}
                    aria-hidden="true"
                  ></i>
                )}
              </div>
            }
          />
        </Tabs>
        <div
          className={`bankAddRuleHeader mb-3 ${
            isDynamicTable ? "listHeaderPaddingRight" : ""
          }`}
        >
          <div
            style={{
              display: "flex",
              padding: "1.5rem 0",
              alignItems: "center",
            }}
          ></div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <TextField
              id="standard-basic"
              label="Search"
              variant="standard"
              sx={{ mr: 1 }}
              onKeyUp={(e) => searchData(e)}
              InputProps={{
                endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
              }}
            />

            <Button
              variant="contained"
              size="small"
              color="warning"
              sx={{
                ml: 2,
              }}
              component={Link}
              to="/app/fx-rate-campaign/0"
            >
              Create New Campaign
            </Button>
          </div>
        </div>

        <CustomTable
          setDynamicTable={setDynamicTable}
          data={
            activeTab === 0
              ? filterList(activeCampaigns, searchKey)
              : filterList(archivedCampaigns, searchKey)
          }
          columns={columns}
          defaultRowPerPage={100}
        />
      </Box>
    </>
  );
}

export default FxCompaignList;
